import type { ReactNode } from "react";
import { COLOR_MAP } from "./menu.config";

export function IconBadge({
  children,
  colorKey,
}: {
  children: ReactNode;
  colorKey: keyof typeof COLOR_MAP | null;
}) {
  const c = colorKey ? COLOR_MAP[colorKey] : null;
  const badge = c ? c.badge : "bg-gray-100";
  const icon = c ? c.icon : "text-gray-600";
  return (
    <span className={`grid h-7 w-7 place-items-center rounded-lg ${badge}`}>
      <span className={`${icon}`}>{children}</span>
    </span>
  );
}
